<template>
  <div class="h5-page-download">
    <div class="brower-tip" v-show="showBrowserTip">
      第一步：点击右上角<i class="more">…</i>
      <br>
      第二步：选择“<i class="iconfont icon-liulanqi"></i>{{isIOS ? 'Safari' : '在浏览器打开'}}”快速打开环保小智
    </div>
    <div class="logo">
      <img src="https://image.qsyhbgj.com/img-logo-circle.png" alt="">
    </div>
    <div class="des">
     「环保小智」是一个「环保专业的云端知识库」，前身为环保手册，收录20000多份环保文件、环评报告、验收报告、场调报告、应急预案，是科技环保理念下的一款创新产品，是我们广大热爱环保人士的贴心助手。
    </div>
    <div class="link">
      <div class="tip">请根据您使用的设备类型点击以下链接下载相应版本的环保小智:</div>
      <div>
        <i class="icon-anzhuo iconfont"></i>
        <!-- <a href="https://a.app.qq.com/o/simple.jsp?pkgname=uni.UNI64594D6">安卓版本<span style="font-weight:bold;">(点击此处下载)</span></a> -->
        <a :href = androidurl>安卓版本<span style="font-weight:bold;">(点击此处下载)</span>（在微信中打开时，请点击右上角，选择‘在浏览器打开’）</a>
      </div>
      <div>
        <i class="icon-pingguo iconfont"></i>
        <a href="https://image.qsyhbgj.com/ulink/index.html">苹果版本<span style="font-weight:bold;">(点击此处下载)</span></a>
      </div>
      <div v-if="winVersion">
        <i class="icon-Windowslogo iconfont"></i>
        <a :href="`https://image.qsyhbgj.com/%E7%8E%AF%E4%BF%9D%E5%B0%8F%E6%99%BA%20Setup%20${winVersion}.exe`">windows电脑版<span style="font-weight:bold;">(点击此处下载)</span>（请在非微信浏览器中点击）</a>
      </div>
      <div v-if="macVersion">
        <i class="icon-mac iconfont"></i>
        <!-- <a :href="`https://image.qsyhbgj.com/%E7%8E%AF%E4%BF%9D%E5%B0%8F%E6%99%BA-${macVersion}.dmg`">mac电脑版<span style="font-weight:bold;">(点击此处下载)</span></a> -->
        <!-- <a :href="`https://image.qsyhbgj.com/%E7%8E%AF%E4%BF%9D%E5%B0%8F%E6%99%BA-0.1.92.dmg`">mac电脑版<span style="font-weight:bold;">(点击此处下载)</span></a> -->
        <a :href="`https://image.qsyhbgj.com/%E7%8E%AF%E4%BF%9D%E5%B0%8F%E6%99%BA-0.1.94.dmg`">mac电脑版<span style="font-weight:bold;">(点击此处下载)</span></a>
      </div>
      <div v-if="macVersion">
        <!-- <i class="icon-Windowslogo iconfont"></i> -->
        <a href="http://hbxz.qsyhbgj.com/admin/环保小智_0.1.94_amd64.deb"><img src="../assets/linux.png" width="16" height="16">linux电脑版(deb)<span style="font-weight:bold;">(点击此处下载)</span></a>
        <!-- <a href="https://image.qsyhbgj.com/环保小智_0.1.77_amd64.deb"><img src="../assets/linux.png" width="16" height="16">linux电脑版(deb)<span style="font-weight:bold;">(点击此处下载)</span></a> -->
      </div>
      <div v-if="macVersion">
        <!-- <i class="icon-Windowslogo iconfont"></i> -->
        <a href="http://hbxz.qsyhbgj.com/admin/环保小智-0.1.94.AppImage"><img src="../assets/linux.png" width="16" height="16">linux电脑版(AppImage)<span style="font-weight:bold;">(点击此处下载)</span></a>
        <!-- <a href="https://hbxz.qsyhbgj.com/环保小智-0.1.77.AppImage"><img src="../assets/linux.png" width="16" height="16">linux电脑版(AppImage)<span style="font-weight:bold;">(点击此处下载)</span></a> -->
      </div>
      <div v-if="macVersion">
        <!-- <i class="icon-Windowslogo iconfont"></i> -->
        <a href="http://hbxz.qsyhbgj.com/admin/环保小智_0.1.94_amd64 .rpm"><img src="../assets/linux.png" width="16" height="16">linux电脑版(rpm)<span style="font-weight:bold;">(点击此处下载)</span></a>
        <!-- <a href="https://image.qsyhbgj.com/环保小智_0.1.77_amd64 .rpm"><img src="../assets/linux.png" width="16" height="16">linux电脑版(rpm)<span style="font-weight:bold;">(点击此处下载)</span></a> -->
      </div>
    </div>
    <div class="intro" v-if="$route.query.type === 'public'">
      <div class="intro-title">发布公示流程</div>
      <img src="https://image.qsyhbgj.com/img-public.png" alt="">
    </div>
    <div class="intro" v-if="$route.query.type === 'register'">
      <div class="intro-title">注册流程</div>
      <img src="https://image.qsyhbgj.com/img-register-download" alt="">
    </div>
  </div>
</template>

<script>
import detect from '../util/detect'
import api from '../../api/index'
export default {
  data () {
    return {
      showBrowserTip: false,
      isIOS: detect.isIOS,
      winVersion: '',
      macVersion: '',
      androidurl: ''
    }
  },
  mounted () {
    /* if (detect.isAndroid) {
      // location.href = `http://a.app.qq.com/o/simple.jsp?pkgname=uni.UNI64594D6&ckey=${this.$route.query.ckey || 'CK1464101221274'}`
      location.href = 'http://a.app.qq.com/o/simple.jsp?pkgname=uni.UNI64594D6'
    } else if (detect.isIOS) {
      location.href = 'https://image.qsyhbgj.com/ulink/index.html'
    } */
    api.getVersionWin().then(res => {
      res.split && (this.winVersion = res.split('\n')[0].split(': ')[1])
    })
    api.getVersionMac().then(res => {
      res.split && (this.macVersion = res.split('\n')[0].split(': ')[1])
    })
    api.checkUpdate({
      version: '1.0.0'
    }).then(res => {
      this.androidurl = res.data.androidurl
    })
  },
  methods: {},
  filters: {}
}
</script>

<style lang="scss">
.h5-page-download {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  // text-align: center;
  .brower-tip {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: auto;
    background: rgba(0, 0, 0, 0.4);
    padding: 12px 8px;
    color: #fff;
    text-align: right;
    .more {
      // transform: rotate(90deg);
      display: inline-block;
      position: relative;
      font-size: 24px;
      top: -4px;
      padding: 0px 4px;
    }
  }
  .des {
    text-indent: 2em;
    padding: 8px;
    color: #83889a;
    max-width: 600px;
  }
  .logo img {
    margin: 40px auto 20px;
    width: 120px;
    height: 120px;
  }
  .link {
    margin-top: 24px;
    padding: 0 24px;
    .tip {
      margin-bottom: 8px;
      font-size: 20px;
      color: black;
      font-weight: bold;
    }
    & > div {
      a {
        color: #333;
        &:hover {
          color: #409eff;
        }
      }
      margin-bottom: 2px;
      .iconfont {
        margin-right: 4px;
      }
    }
  }
  .intro {
    padding: 20px 0 40px 0;
    text-align: center;
    .intro-title {
      color: #409eff;
      text-align: center;
      width: 98%;
      max-width: 680px;
      margin: 0 auto;
      padding: 4px 0;
    }
    img {
      width: 98%;
      max-width: 680px;
    }
  }
}
</style>
